import React from "react";
import { useSelector, useDispatch } from "react-redux";
import PinRequiredDialog from "./pinRequiredDialog.component";
import { updatePinRequiredStatus } from "modules/serial-number/redux/action/serialNumberBatch.action";

export default function PinRequiredDialogContainer({
  pendingPinChange,
  open,
  onClose,
}) {
  const lang = useSelector((state) => state.constant.languages);
  const dispatch = useDispatch();

  const handleConfirm = () => {
    if (pendingPinChange?.uuid) {
      dispatch(
        updatePinRequiredStatus({
          id: pendingPinChange.uuid,
          pinRequired: !pendingPinChange.pinRequired,
        })
      );
    }
    if (onClose) onClose();
  };

  return (
    <PinRequiredDialog
      open={open}
      lang={lang}
      pendingPinChange={pendingPinChange}
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  );
}